import { render, staticRenderFns } from "./CustomerEditDialog.vue?vue&type=template&id=66e664cc&scoped=true"
import script from "./CustomerEditDialog.vue?vue&type=script&lang=js"
export * from "./CustomerEditDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditDialog.vue?vue&type=style&index=0&id=66e664cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e664cc",
  null
  
)

export default component.exports